import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        width: "100%",
        height: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        background: theme.palette.primary.main,
    },
    titleContainer: {
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        width: "100%",
    },
    title: {
        color: theme.palette.info.main,
        fontWeight: "600 !important",
    },
    infoContainer: {
        padding: `0 ${theme.spacing(6)}`,
    },
    seeMoreButton: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        width: "100%",
        borderWidth: 0,
        padding: `${theme.spacing(3)} 0`,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        cursor: "pointer",
    },
    icon: {
        color: theme.palette.primary.dark,
    },
    graphContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        position: "relative",
        marginTop: theme.spacing(5),
    },
    graphGridItemContainer: {
        height: "38vh !important",
        "@media (min-width: 1600px)": {
            height: "33vh !important",
        },
        display: "flex",
        position: "relative",
    },
    totalDowntimeBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "absolute",
        left: "11%",
        "@media (min-width: 1600px)": {
            left: "22%",
            bottom: "1%",
        },
        bottom: "0",
    },
    totalDowntimeTitle: {
        fontSize: 12,
        color: theme.palette.primary.dark,
    },
    totalDowntimeNumber: {
        color: theme.palette.text.secondary,
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
}));
